{
  "id": "b2-vocabulary-30",
  "name": "B2 Frequency Band 30 (1451-1500)",
  "description": "B2 level French frequency vocabulary",
  "examGrade": "B2",
  "difficulty": "advanced",
  "source": "French subtitle frequency list",
  "sourceUrl": "https://github.com/hermitdave/FrequencyWords",
  "category": "general",
  "words": [
    {
      "id": "fr:vocab:4452:cess",
      "word": "cessé",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4104
    },
    {
      "id": "fr:vocab:4453:fonction",
      "word": "fonction",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4101
    },
    {
      "id": "fr:vocab:4454:lame",
      "word": "lame",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4101
    },
    {
      "id": "fr:vocab:4455:donnait",
      "word": "donnait",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4100
    },
    {
      "id": "fr:vocab:4456:navr-e",
      "word": "navrée",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4098
    },
    {
      "id": "fr:vocab:4457:shawn",
      "word": "shawn",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4097
    },
    {
      "id": "fr:vocab:4458:cach-e",
      "word": "cachée",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4096
    },
    {
      "id": "fr:vocab:4459:salopard",
      "word": "salopard",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4093
    },
    {
      "id": "fr:vocab:4460:cuir",
      "word": "cuir",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4093
    },
    {
      "id": "fr:vocab:4461:monica",
      "word": "monica",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4093
    },
    {
      "id": "fr:vocab:4462:megan",
      "word": "megan",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4084
    },
    {
      "id": "fr:vocab:4463:direz",
      "word": "direz",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4083
    },
    {
      "id": "fr:vocab:4464:goutte",
      "word": "goutte",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4083
    },
    {
      "id": "fr:vocab:4465:rate",
      "word": "rate",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4082
    },
    {
      "id": "fr:vocab:4466:ticket",
      "word": "ticket",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4082
    },
    {
      "id": "fr:vocab:4467:douter",
      "word": "douter",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4081
    },
    {
      "id": "fr:vocab:4468:chlo",
      "word": "chloé",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4081
    },
    {
      "id": "fr:vocab:4469:f-d-ral",
      "word": "fédéral",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4081
    },
    {
      "id": "fr:vocab:4470:stephen",
      "word": "stephen",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4080
    },
    {
      "id": "fr:vocab:4471:maths",
      "word": "maths",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4076
    },
    {
      "id": "fr:vocab:4472:ose",
      "word": "ose",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4072
    },
    {
      "id": "fr:vocab:4473:attaques",
      "word": "attaques",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4070
    },
    {
      "id": "fr:vocab:4474:autoroute",
      "word": "autoroute",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4069
    },
    {
      "id": "fr:vocab:4475:accuser",
      "word": "accuser",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4068
    },
    {
      "id": "fr:vocab:4476:dealer",
      "word": "dealer",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4066
    },
    {
      "id": "fr:vocab:4477:d-position",
      "word": "déposition",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4066
    },
    {
      "id": "fr:vocab:4478:victoria",
      "word": "victoria",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4066
    },
    {
      "id": "fr:vocab:4479:tonne",
      "word": "étonne",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4065
    },
    {
      "id": "fr:vocab:4480:deuil",
      "word": "deuil",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4062
    },
    {
      "id": "fr:vocab:4481:occupe-toi",
      "word": "occupe-toi",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4062
    },
    {
      "id": "fr:vocab:4482:l-g-re",
      "word": "légère",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4057
    },
    {
      "id": "fr:vocab:4483:huh",
      "word": "huh",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4056
    },
    {
      "id": "fr:vocab:4484:avocate",
      "word": "avocate",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4056
    },
    {
      "id": "fr:vocab:4485:statue",
      "word": "statue",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4055
    },
    {
      "id": "fr:vocab:4486:excellence",
      "word": "excellence",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4053
    },
    {
      "id": "fr:vocab:4487:coule",
      "word": "coule",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4051
    },
    {
      "id": "fr:vocab:4488:arm-s",
      "word": "armés",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4051
    },
    {
      "id": "fr:vocab:4489:piqu",
      "word": "piqué",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4051
    },
    {
      "id": "fr:vocab:4490:eva",
      "word": "eva",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4048
    },
    {
      "id": "fr:vocab:4491:p-res",
      "word": "pères",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4047
    },
    {
      "id": "fr:vocab:4492:basket",
      "word": "basket",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4046
    },
    {
      "id": "fr:vocab:4493:harris",
      "word": "harris",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4046
    },
    {
      "id": "fr:vocab:4494:",
      "word": "ô",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4044
    },
    {
      "id": "fr:vocab:4495:path-tique",
      "word": "pathétique",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4043
    },
    {
      "id": "fr:vocab:4496:x",
      "word": "x",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4039
    },
    {
      "id": "fr:vocab:4497:journalistes",
      "word": "journalistes",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4039
    },
    {
      "id": "fr:vocab:4498:remarquer",
      "word": "remarquer",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4038
    },
    {
      "id": "fr:vocab:4499:booth",
      "word": "booth",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4037
    },
    {
      "id": "fr:vocab:4500:matthew",
      "word": "matthew",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4037
    },
    {
      "id": "fr:vocab:4501:innocente",
      "word": "innocente",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4035
    }
  ]
}